module.exports = __webpack_public_path__ + "media/geometric_background_4k.f68b6e37.mp4";